export const HOST = process.env.REACT_APP_HOST || 'https://api.youber.app';

export const API_VERSION = 1;

export const RECAPTCHA_SITE_KEY = '6LdHZJgaAAAAACJCBV66-meW65U46mdyAH51sddp';
